<template>
  <v-bottom-sheet v-model="bottomSelectFlag">
    <v-sheet :height="sheetHeightObj.sheet" class="bottom-sheet-wrap">
      <v-row class="ma-0">
        <v-col cols="12" class="pa-0">
          <v-container :style="containerStyle" class="pa-0 overflow-y-auto">
            <div class="sheet-title">{{ title }}</div>
            <div class="sheet-desc" v-scroll.self="onScroll">
              <v-list>
                <v-list-item-group color="primary">
                  <v-list-item
                    v-for="(item, i) in list"
                    :key="i"
                    @click="$emit('selectItem', item)"
                  >
                    <v-list-item-content>
                      <v-list-item-title style="white-space: normal;" v-text="item.codeNm"></v-list-item-title>
                    </v-list-item-content>
                  </v-list-item>
                </v-list-item-group>
              </v-list>
            </div>
          </v-container>
        </v-col>
      </v-row>
    </v-sheet>
  </v-bottom-sheet>
</template>

<script>
export default {
  props: {
    list: {
      type: Array,
    },
    title: {
      type: String,
    },
    flag: {
      type: Boolean,
    },
    sheetHeightObj: {
      type: Object,
      default() {
        return { sheet: '283px', container: '253px' };
      },
    },
  },
  data: () => ({
    bottomSelectFlag: false,
  }),
  watch: {
    flag() {
      this.bottomSelectFlag = !this.bottomSelectFlag;
    },
  },

  computed: {
    containerStyle() {
      return {
        'max-height': this.sheetHeightObj.container,
      };
    },
  },
  methods: {
    onScroll() {},
  },
  components: {},
};
</script>
<style>
.picker-group {
  display: flex;
}

/* bottom-sheet */
.bottom-sheet-wrap {
  border-radius: 20px 20px 0 0;
}
.sheet-title {
  padding: 30px 24px 20px;
  font-weight: bold;
  line-height: 1.5;
  color: #363c43;
}

</style>
